<template>
  <md-content>
    <md-button
      native-type="button"
      @click.native.prevent="onPickFile"
      :class="className"
      :disabled="disabled"
      ref="button"
      >{{ label }}
    </md-button>
    <input
      type="file"
      style="display: none"
      ref="fileInput"
      :accept="getContentTypes"
      @change="onFilePicked"
    />
  </md-content>
</template>
<script>
export default {
  data() {
    return {
      fileData: null
    };
  },
  props: ["label", "className", "contentTypes", "disabled"],
  computed: {
    getContentTypes: function() {
      if (Array.isArray(this.contentTypes)) {
        return this.contentTypes.join(",");
      }
      return this.contentTypes;
    }
  },
  methods: {
    init() {
      //
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked() {
      const files = event.target.files;

      if (files.length === 0) {
        return;
      }

      // let filename = files[0].name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        let imageUrl = fileReader.result;

        this.$emit("input", {
          filename: files[0].name,
          fileData: imageUrl
        });
      });
      fileReader.readAsDataURL(files[0]);
      // this.file = Files[0];
    }
  },
  created() {
    this.init();
  }
};
</script>
<style scoped>
div.md-content button.md-button {
  width: 99%;
}
</style>
